import { render, staticRenderFns } from "./BadgeOriginChip.vue?vue&type=template&id=3356fad3&scoped=true"
import script from "./BadgeOriginChip.vue?vue&type=script&lang=js"
export * from "./BadgeOriginChip.vue?vue&type=script&lang=js"
import style0 from "./BadgeOriginChip.vue?vue&type=style&index=0&id=3356fad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356fad3",
  null
  
)

export default component.exports